import styled from '@emotion/styled';
import { Text } from 'ds/components/typography';
import { Button } from 'ds/components/button';

export const Root = styled.div<{ modeB?: boolean }>(({ theme, modeB }) => ({
  flexGrow: 1,
  padding: theme.spacing(2.5),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  background: theme.colors.brand.lightBlue,
  boxShadow: '-1px 0px 0px 0px rgba(0, 0, 0, 0.12), 0px -1px 0px 0px rgba(0, 0, 0, 0.12)',
  'button, a': {
    maxWidth: modeB ? 'unset' : '200px',
    width: modeB ? 'auto' : '100%',
  },
  '.contact-buttons': {
    flexShrink: 0,
  },
  'button:disabled': {
    maxWidth: '230px',
  },
}));

export const InfoBox = styled.div(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  gap: theme.spacing(1.5),
}));

export const UserName = styled(Text)(({ theme }) => ({
  color: theme.colors.neutrals.grey1,
}));

export const ButtonWrapper = styled.div(({ theme }) => ({
  display: 'flex',
  flexShrink: 0,
  gap: theme.spacing(2),
  [theme.media.createObjectMediaQuery({ to: 2 })]: {
    flexGrow: 1,
    justifyContent: 'space-between',
  },
}));

export const PhoneButton = styled(Button.withComponent('a'))(({ theme }) => ({
  textDecoration: 'none',
  whiteSpace: 'nowrap',
  svg: {
    marginLeft: theme.spacing(1),
  },
}));
